import { Card } from "@mantine/core";
import { getDateMonthFromTimestamp, capitalizeFirstLetter } from "@/lib/utils";
import { useAccessRequest } from "@/context/access-request-context";

export default function CompanyDetails() {
	const { requestDetails } = useAccessRequest();
	return (
		<>
			<Card.Section className="p-4">
				<div className="grid md:grid-cols-8 grid-cols-1 gap-8 py-5">
					<div className="col-span-2">
						<div className="text-sm text-textColor mb-1">Client Id</div>
						<div className="font-medium text-textColor">
							{requestDetails?.clientId ? requestDetails?.clientId : "Pending"}
						</div>
					</div>
					<div>
						<div className="text-sm text-textColor mb-1">Company Name</div>
						<div className="font-medium text-textColor">
							{requestDetails?.institutionName}
						</div>
					</div>
					<div>
						<div className="text-sm text-textColor mb-1">Submitted on</div>
						<div className="font-medium text-textColor">
							{getDateMonthFromTimestamp(requestDetails?.createdAt)}
						</div>
					</div>
					<div>
						<div className="text-sm text-textColor mb-1">
							Accepted CBDC Terms
						</div>
						<div className="font-medium text-textColor">
							{requestDetails?.hasAcceptedCBDCTerms ? "Yes" : "No"}
						</div>
					</div>
					<div className="col-span-2">
						<div className="text-sm text-textColor mb-1">
							Application Status
						</div>
						<div className="font-medium text-textColor">
							{requestDetails?.approvalStatus ? (
								requestDetails.approvalStatus === "APPROVED" ? (
									<div>
										<span className="inline-block px-3 py-1 text-xs font-medium text-textColor bg-emerald-500 rounded-full">
											{capitalizeFirstLetter(requestDetails?.status)}
										</span>
									</div>
								) : requestDetails.approvalStatus === "DENIED" ||
									requestDetails.approvalStatus === "DECLINED" ||
									requestDetails.approvalStatus === "REVOKED" ? (
									<div>
										<span className="inline-block px-3 py-1 text-xs font-medium text-textColor bg-red-500 rounded-full">
											{capitalizeFirstLetter(requestDetails?.status)}
										</span>
									</div>
								) : (
									<div>
										<span className="inline-block px-3 py-1 text-xs font-medium text-textColor bg-yellow-500 rounded-full">
											{capitalizeFirstLetter(requestDetails?.status)}
										</span>
									</div>
								)
							) : (
								<div>
									<span className="inline-block px-3 py-1 text-xs font-medium text-textColor bg-yellow-500 rounded-full">
										PENDING
									</span>
								</div>
							)}
						</div>
					</div>
				</div>
			</Card.Section>
		</>
	);
}
